module.exports = __webpack_public_path__ + "img/C-03-min.d963c6da.png";